import * as _ from 'lodash'
import { validate } from 'class-validator-multi-lang'
import qs from 'qs'
import i18n from '@/admin/plugins/i18n'
import { Enumify } from 'enumify'

const snapshotSymbol = Symbol('snapshot')
const errorsSymbol = Symbol('errors')
const errorSymbol = Symbol('error')

export class Model {
  get $errors() {
    return this[errorsSymbol]
  }

  set $errors(value) {
    this[errorsSymbol] = value
  }

  get $error() {
    return this[errorSymbol]
  }

  set $error(value) {
    this[errorSymbol] = value
  }

  get validateTitles() {
    return {}
  }

  /**
   *
   * @returns {Promise<boolean>} 유효성 체크 결과 true:유효 false:유효하지 않음
   */
  async validate(options = {}) {
    const validatorOptions = _.assign(
      {
        titles: this.validateTitles,
      },
      options
    )
    const errors = await validate(this, validatorOptions)
    _.keys(this.$errors).forEach((key) => _.unset(this.$errors, key))
    if (errors.length) {
      for (const error of errors) {
        this.$errors[error.property] = _.values(error.constraints)[0]
        //this.$errors[error.property] = _.values(error.constraints).join('')
      }
      this.$error = true
      return false
    }
    this.$error = false
    return true
  }

  snapshot() {
    this[snapshotSymbol] = _.cloneDeep(this)
  }

  getSnapshot() {
    return this[snapshotSymbol]
  }

  rollback(property) {
    if (property) {
      this[property] = this[snapshotSymbol][property]
    } else {
      this.assign(this[snapshotSymbol])
    }
  }

  hasChanged(property) {
    const snapshot = this[snapshotSymbol]
    if (property) {
      return !this.equals(snapshot[property], this[property])
    }
    return !_.keys(snapshot).reduce(
      (acc, key) => acc && this.equals(snapshot[key], this[key]),
      true
    )
  }

  initialize(data) {
    this.$errors = {}
    this.$error = false
    _.assign(this, data)

    this.snapshot()
  }

  equals(a, b) {
    return _.isEqual(a, b)
  }

  assign(data) {
    _.assign(this, data)
  }
}

export async function exists(axios, url, data) {
  try {
    let response = await axios.get(url, {
      data: data,
      preventDefault: true,
    })
    return !!response.data
  } catch (e) {
    if (e.response.status == 404) {
      return false
    } else {
      typeof e.resumePreventDefault === 'function' && e.resumePreventDefault()
      throw e
    }
  }
}

export class Sort {
  constructor(field, dir = 'ASC') {
    if (!field) {
      throw new Error('field is null')
    }
    this.field = field
    this.dir = dir.toUpperCase()
  }

  static toQueryString(sorts) {
    return qs.stringify(
      sorts.map((s) => {
        let o = {}
        o[s.field] = s.dir
        return o
      }),
      {
        arrayFormat: 'repeat',
      }
    )
  }

  static parseQueryString(queryString) {
    let parsed = qs.parse(queryString)
    return _.values(parsed).map((o) => {
      let sort
      _.forIn(o, (value, key) => {
        sort = new Sort(key, value)
      })
      return sort
    })
  }

  static createSort(field, dir) {
    return new Sort(field, dir)
  }

  getField() {
    return this.field
  }

  getDir() {
    return this.dir
  }

  static sort(array, sorters) {
    if (sorters && sorters.length) {
      const fields = []
      const dirs = []
      sorters.forEach((sorter) => {
        fields.push(sorter.getField())
        dirs.push(sorter.getDir().toLowerCase())
      })
      return _.orderBy(array, fields, dirs)
    }
    return [...array]
  }
}

export class DefaultModel extends Model {
  constructor(data) {
    super()
    this.initialize(data)
  }
}

export class I18nEnumify extends Enumify {
  #i18n

  get label() {
    return i18n.global.t(this.#i18n)
  }

  constructor(i18nKey) {
    super()
    this.#i18n = i18nKey
  }

  static toLabelMap() {
    const map = {}
    this.enumValues.forEach((e) => {
      // noinspection JSUnresolvedVariable
      map[e.enumKey] = e.label
    })
    return map
  }

  static toLabelArray(keyProperty = 'value', labelProperty = 'label') {
    // noinspection JSUnresolvedVariable
    return this.enumValues.map((e) => ({
      [keyProperty]: e.enumKey,
      [labelProperty]: e.label,
    }))
  }

  /**
   *
   * @param str
   * @returns {}
   */
  static enumValueOf(str) {
    return super.enumValueOf(str)
  }
}
